<template>
  <div class="RwvAuthor">
    <div class="banner dark-banner">
      <div class="inner-section">
        <div v-if="author.image" class="avatar-image">
          <!-- <img :src="post.author.image" /> -->
          <img :src="author.image"/>
        </div>
        <h1>{{author.name.title + " " + author.name.name + " " + author.name.surname}}</h1>
        <h6>{{author.description}}</h6>
        <b-button
          size="sm"
          variant="outline-warning"
          v-if="isAuthenticated"
          :to="{ name: 'author-edit', params: { slug: author.slug } }">

          <i class="material-icons">edit</i><span>&nbsp;Bearbeiten</span>
        </b-button>
      </div>
    </div>
    <div class="inner-section">
      <RwvContent
        v-for="(content, index) in author.content"
        :key="index"
        :content="content"
        :index="index">
      </RwvContent>
    </div>
  </div>
</template>

<script>
import RwvContent from "@/components/Contents/Content";

export default {
  name: "RwvAuthor",
  components: {
    RwvContent
  },
  props: {
    author: {
      type: Object,
      required: true
    },
    isAuthenticated: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style>
</style>
